import React from 'react';
import MapaRecinto3D from '../../../components/recintos/MapaRecinto3D';

export default function SelectorZonaDestino({zonas, disponibles, origenId, seleccionadaId, onSelect, plano, disabled, modo}) {
  const permitidas = new Set(disponibles.map(z => z.id));
  const seleccionada = disponibles.find(z => z.id === seleccionadaId);
  return <section className="destino-planimetria" aria-label="Zona destino">
    <h5>Escoge la zona de destino en el mapa</h5>
    <p>{modo === 'intercambiar' ? 'Selecciona una zona con reserva para intercambiarla.' : 'Selecciona una zona libre para trasladar la reserva.'} Desliza el mapa para recorrer todas las zonas.</p>
    <div className="destino-leyenda"><span>🟢 Libre</span><span>🟡 Reservada</span><span>🔴 Prepagada</span><span>✓ Borde blanco: selección</span></div>
    <MapaRecinto3D plano={plano} zonas={zonas} seleccionadaId={seleccionadaId} disabled={disabled}
      disabledIds={zonas.filter(z=>!permitidas.has(z.id)).map(z=>z.id)}
      onZonaClick={z=>{if(!disabled&&permitidas.has(z.id))onSelect(z.id);}}/>
    <div className="destino-seleccion" role="status">{seleccionada ? <><b>Destino: {seleccionada.label}</b>{seleccionada.reserva && <span>Reserva de {seleccionada.reserva.nombreCliente}</span>}</> : disponibles.length ? 'Ninguna zona seleccionada.' : 'No hay zonas disponibles para esta operación.'}</div>
  </section>;
}
